module.exports = __webpack_public_path__ + "img/ico_setting_white.c9c7f583.svg";